import React from "react";
import PropTypes from "prop-types";

function QuoteResult({ gid }) {
  return <div>Quote: {JSON.stringify(gid)}</div>;
}

QuoteResult.propTypes = {
  gid: PropTypes.string.isRequired,
};
export default QuoteResult;
